import { render } from "./ChannelsSummary.vue?vue&type=template&id=2808a975&scoped=true"
import script from "./ChannelsSummary.vue?vue&type=script&lang=js"
export * from "./ChannelsSummary.vue?vue&type=script&lang=js"

import "./ChannelsSummary.vue?vue&type=style&index=0&id=2808a975&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2808a975"]])

export default __exports__